/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.element("<div/>")
    @Serenity.Decorators.registerEditor([Serenity.IGetEditValue, Serenity.ISetEditValue, Serenity.IReadOnly])
    export class TestGroupTestsEditor extends Common.GridEditorBase<TestGroupTestRow> implements Serenity.IReadOnly {
        protected getColumnsKey() { return 'Data.TestGroupTests'; }
        protected getIdProperty() { return 'TestCode'; }

        private rowSelection: Serenity.GridRowSelectionMixin;

        constructor(container: JQuery) {
            super(container);

            this.rowSelection = new Serenity.GridRowSelectionMixin(this);

            this.slickGrid.setSelectionModel(new Slick.RowSelectionModel());
            Serenity.GridUtils.makeOrderable(this.slickGrid, (items: number[], location: number) => {
                if (!items || !items.length)
                    return;

                this.moveItem(items[0], location);
            });

            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.enableAsyncPostRender = true;
            opt.asyncPostRenderDelay = -1;
            opt.enableAsyncPostRenderCleanup = true;
           
            return opt;
        }

        private changeSequenceWithChildren(row: number, value: number) {
            value = +(value.toFixed(3));
            var items = this.view.getItems();
            var item = items[row];
            var oldSequence = item.SequenceNumber;
            var d = this.getDepth(oldSequence);
            item.SequenceNumber = value;
            var current = row + 1;
            var c;
            while (current < items.length && this.getDepth((c = items[current]).SequenceNumber) > d) {
                c.SequenceNumber = +((item.SequenceNumber - oldSequence + c.SequenceNumber).toFixed(3));
                this.view.updateItem(c.TestCode, c);
                current++;
            }
        }

        private moveItem(from, to: number) {
            if (this._readOnly)
                return;

            if (from == to)
                return;

            var items = this.view.getItems();
            if (to >= items.length)
                return;

            var fromItem = items[from];
            var toSequence = items[to].SequenceNumber;

            if (Q.startsWith(this.formatSequence(toSequence), this.formatSequence(fromItem.SequenceNumber))) {
                Q.notifyWarning("Can't move item under its children!");
                return;
            }

            var depth = this.getDepth(fromItem.SequenceNumber);
            var parent = this.getParent(from);
            if (depth != this.getDepth(toSequence) || parent != this.getParent(to)) {
                Q.notifyWarning("Can only move item among its siblings!");
                return;
            }

            var step = Math.pow(10, -depth);

            for (var i = parent == null ? 0 : parent + 1; i < items.length; i++) {
                var di = this.getDepth(items[i].SequenceNumber);
                if (di < depth)
                    break;

                if (di != depth)
                    continue;

                if (i < from && i < to)
                    continue;

                if (from < to) {
                    if (i == from)
                        this.changeSequenceWithChildren(i, toSequence - step);
                    else if (i < to)
                        this.changeSequenceWithChildren(i, items[i].SequenceNumber - step);
                }
                else {
                    if (i == from)
                        this.changeSequenceWithChildren(i, toSequence);
                    else if (i < from)
                        this.changeSequenceWithChildren(i, items[i].SequenceNumber + step);
                }
            }

            items.sort((x, y) => x.SequenceNumber - y.SequenceNumber);
            this.view.setItems(items, false);
        }

        protected processValue(value: TestGroupTestRow[]): TestGroupTestRow[] {
            value = super.processValue(value);
            value.sort((x, y) => x.SequenceNumber - y.SequenceNumber);
            return value;
        }

        private getDepth(n: number) {
            var val = n || 0;
            val = val - Math.floor(val);
            val = Q.formatNumber(val, '0.######').length - 2;
            if (val < 0)
                val = 0;
            return val;
        }

        private formatSequence(n: number) {
            var s = n.toString();
            if (s.indexOf('.') < 0)
                return s;
            var p = s.split('.');
            s = p[1];
            if (s.length == 2)
                s = s.substr(0, 1) + '.' + s.substr(1, 1);
            else if (s.length == 3)
                s = s.substr(0, 1) + '.' + s.substr(1, 1) + '.' + s.substr(2, 1);
            return p[0] + '.' + s;
        }

        private getPriorSiblingOrParent(row: number) {
            if (row <= 0)
                return null;

            var prior = this.itemAt(row - 1);
            var d = this.getDepth(this.itemAt(row).SequenceNumber);
            var current = row - 1;
            while (current > 0 && this.getDepth(prior.SequenceNumber) >= d) {
                current--;
                prior = this.itemAt(current);
            }
            return prior;
        }

        private getParent(row: number) {
            if (row <= 0)
                return null;

            var d = this.getDepth(this.itemAt(row).SequenceNumber);
            if (d == 0)
                return null;

            var current = row - 1;
            while (current >= 0) {
                if ((this.getDepth(this.itemAt(current).SequenceNumber)) < d) {
                    return current;
                }
                current--;
            }

            return null;
        }

        protected getColumns() {
            var columns = super.getColumns();

            columns[0].behavior = "selectAndMove";
            columns[0].asyncPostRender = (cellNode: any, row: number, item: TestGroupTestRow) => {
                if (this._readOnly) {
                    cellNode.html(item.SequenceNumber);
                }
            } 

            var rowSelectColumn = Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection);
            rowSelectColumn.asyncPostRender = (cellNode: any) => {

                if (this._readOnly) {
                    cellNode.html('')
                }
            }

            columns.splice(0, 0, rowSelectColumn);

            columns.splice(1, 0, {
                field: '_left_',
                name: ' ',
                width: 20,
                minWidth: 20,
                resizable: false,
                format: ctx => {
                    if (ctx.row <= 0)
                        return "";
                    var d = this.getDepth(ctx.item.SequenceNumber);
                    if (d == 0)
                        return "";
                    var prior = this.getPriorSiblingOrParent(ctx.row);
                    if (d < this.getDepth(prior.SequenceNumber))
                        return "";
                    return "<i class='fa unindent fa-chevron-left'></i>"
                },
                asyncPostRender: (cellNode: any) => {
                    if (this._readOnly) {
                        cellNode.html('')
                    }
                }
            });

            columns.splice(2, 0, {
                field: '_right_',
                name: ' ',
                width: 20,
                minWidth: 20,
                resizable: false,
                format: ctx => {
                    if (ctx.row <= 0)
                        return "";
                    var d = this.getDepth(ctx.item.SequenceNumber);
                    if (d >= 3 || d > this.getDepth(this.itemAt(ctx.row - 1).SequenceNumber))
                        return "";
                    var current = ctx.row + 1;
                    var items = this.view.getItems();
                    var d2;
                    while (current < items.length && (d2 = this.getDepth(items[current].SequenceNumber)) > d) {
                        if (d2 >= 3)
                            return "";
                        current++;
                    }
                    return "<i class='fa indent fa-chevron-right'></i>"
                },
                asyncPostRender: (cellNode: any) => {
                    if (this._readOnly) {
                        cellNode.html('')
                    }
                }
            });


            Q.first(columns, x => x.field == 'SequenceNumber').format = ctx => {
                return "<i class='fa fa-bars text-lime pull-right'></i> <span style='padding-left:" + (this.getDepth(ctx.value) * 15) + "px'>" +
                    this.formatSequence(ctx.value) + '</span>';
            };

            Q.first(columns, x => x.field == 'TestCode').format = ctx => {
                return "<span style='padding-left:" + (this.getDepth(ctx.item.SequenceNumber) * 15) + "px'>" + Q.htmlEncode(ctx.value) + '</span>';
            };

            var pb = Q.first(columns, x => x.field == 'ParameterBinding');
            pb.format = ctx => this.stringInputFormatter(ctx);
           
            return columns;
        }


        protected unindentAt(row, scanSameDepth) {
            var item = this.itemAt(row);
            var items = this.view.getItems();
            var d = this.getDepth(item.SequenceNumber);
            var prior = this.getPriorSiblingOrParent(row);

            if (d == 0 || d < this.getDepth(prior.SequenceNumber))
                return;

            if (scanSameDepth) {
                var sameDepthList = [];
                var current = row + 1;
                var dx;
                var lastSameDepth = null;
                while (current < items.length && (dx = this.getDepth((c = items[current]).SequenceNumber)) >= d) {
                    if (dx == d) {
                        sameDepthList.push(current);
                    }
                    current++;
                }

                if (sameDepthList.length) {
                    for (var i = sameDepthList.length - 1; i >= 0; i--) {
                        this.unindentAt(sameDepthList[i], false);
                    }
                }
            }

            var oldSequence = item.SequenceNumber;
            item.SequenceNumber = +((prior.SequenceNumber + Math.pow(10, -(d - 1))).toFixed(3));
            this.view.updateItem(item.TestCode, item);

            var current = row + 1;
            while (current < items.length && this.getDepth((c = items[current]).SequenceNumber) > d) {
                c.SequenceNumber = +((item.SequenceNumber + ((c.SequenceNumber - oldSequence) * 10)).toFixed(3));
                this.view.updateItem(c.TestCode, c);
                current++;
            }

            var increase = Math.pow(10, -(d - 1));
            var c;
            while (current < items.length && this.getDepth((c = items[current]).SequenceNumber) >= d - 1) {
                c.SequenceNumber += increase;
                c.SequenceNumber = +(c.SequenceNumber.toFixed(3));
                current++;
                this.view.updateItem(c.TestCode, c);
            }
        }

        protected onClick(e: JQueryEventObject, row, cell) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var target = $(e.target);
            if (target.hasClass('indent') || target.hasClass('unindent')) {
                e.preventDefault();
                if (row <= 0)
                    return;

                var unindent = target.hasClass('unindent');

                var item = this.itemAt(row);
                var prior = this.itemAt(row - 1);
                var items = this.view.getItems();

                var d = this.getDepth(item.SequenceNumber);
                if (unindent) {
                    this.unindentAt(row, true);
                    this.view.setItems(this.view.getItems(), false);
                }
                else {
                    if (d >= 3 || d > this.getDepth(prior.SequenceNumber))
                        return;

                    var d2;
                    var current = row + 1;
                    while (current < items.length && (d2 = this.getDepth(items[current].SequenceNumber)) > d) {
                        if (d2 >= 3)
                            return;
                        current++;
                    }

                    current = row - 1;
                    while (current > 0 && this.getDepth(prior.SequenceNumber) > d + 1) {
                        current--;
                        prior = items[current];
                    }

                    var oldSequence = item.SequenceNumber;
                    item.SequenceNumber = +((prior.SequenceNumber + Math.pow(10, -(d + 1))).toFixed(3));
                    this.view.updateItem(item.TestCode, item);

                    var decrease = Math.pow(10, -d);

                    var current = row + 1;
                    while (current < items.length && this.getDepth((c = items[current]).SequenceNumber) > d) {
                        c.SequenceNumber = +((item.SequenceNumber + ((c.SequenceNumber - oldSequence) / 10)).toFixed(3));
                        this.view.updateItem(c.TestCode, c);
                        current++;
                    }

                    var c;
                    while (current < items.length && this.getDepth((c = items[current]).SequenceNumber) >= d) {
                        c.SequenceNumber -= decrease;
                        c.SequenceNumber = +(c.SequenceNumber.toFixed(3));
                        current++;
                        this.view.updateItem(c.TestCode, c);
                    }

                    this.view.setItems(this.view.getItems(), false);
                }
            }
        }

        protected getPersistanceStorage() {
            return null;
        }

        protected getInitialTitle() {
            return null;
        }

        private stringInputFormatter(ctx) {
            var klass = 'edit string';
            var item = ctx.item as TestGroupRow;
            var column = ctx.column as Slick.Column;

            var value = item[column.field] as string;
            var isDiabled = this._readOnly ? 'disabled' : '';
            return "<input type='text' class='" + klass +
                "' data-field='" + column.field +
                "' value='" + Q.attrEncode(value) + 
                "' style='width:100%' " + isDiabled+"/>";
        }
        getButtons() {
            var that = this;
            var buttons = [
                {
                    title: 'Add Tests to Group',
                    cssClass: 'add-tests-button',
                    icon: 'fa-search-plus',
                    onClick: () => {
                        var dlg = new TestPickerDialog();
                        dlg.onSuccess = (selected) => {
                            for (var x of selected) {
                                if (this.view.getItemById(x) != null)
                                    continue;

                                var items = this.view.getItems();

                                this.view.addItem({
                                    TestCode: x.TestCode,
                                    TestCodeDescription: x.Description,
                                    TestCodeTestTypeCode: x.TestTypeCode,
                                    SequenceNumber: items.length == 0 ? 1 : Math.floor(items[items.length - 1].SequenceNumber || 0) + 1,
                                    ParameterBinding: null
                                });
                            }

                            return true;
                        };

                        dlg.dialogOpen();
                    }
                }, {
                        title: 'Remove Selected',
                        cssClass: 'remove-selected-button',
                        icon: 'fa-times',
                        onClick: () => {
                            for (var x of this.rowSelection.getSelectedKeys())
                                this.view.deleteItem(x);
                            this.rowSelection.setSelectedKeys([]);
                        }
                },{
                        hint: 'Export to Excel',
                        title: 'Export',
                        cssClass: 'export-xlsx-button',
                        icon: 'fa-file-excel-o',
                        onClick: function () {
                            let grid = that;
                            var request = Q.deepClone(grid.getView().params) as Serenity.RetrieveRequest;
                            request.EntityId = grid.getItems()[0].TestGroupCode;
                            request.IncludeColumns = [];
                            let columns = grid.getGrid().getColumns();
                            for (let column of columns) {
                                request.IncludeColumns.push(column.id || column.field);
                            }
                            Q.postToService({ service: "Data/TestGroup/DownloadExcel" , request: request, target: '_blank' });         
                        },
                        separator: true
            }];

            return buttons;
        }

        private inputsChange(e: JQueryEventObject) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');

            var effective = item[field];
            var oldText: string;
            if (input.hasClass("numeric"))
                oldText = Q.formatNumber(effective, '0.##');
            else
                oldText = effective as string;

            var value;
            value = text;
            item[field] = value;
            this.view.refresh();
        }

        private _readOnly: boolean;

        public get_readOnly() {
            return this._readOnly;
        }

        getViewOptions() {
            var opt = super.getViewOptions();
            opt.localSort = true;
            return opt;
        }

        public set_readOnly(value: boolean) {
            if (!!value !== !!this._readOnly) {
                this._readOnly = !!value;

                this.toolbar.findButton('add-tests-button').toggleClass('disabled', this._readOnly);
                this.toolbar.findButton('remove-selected-button').toggleClass('disabled', this._readOnly);
            }
        }

    }
}